"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Money_1 = __importDefault(require("components/Money"));
var Subtotal = function (_a) {
    var item = _a.item;
    if (!item.subtotal) {
        return null;
    }
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Money_1.default, { amount: item.subtotal, isRounded: true }), "/mo"] });
};
exports.default = Subtotal;
